export function uniqueObjectsByKey(objects, key) {
	const uniqueValues = [];
	const uniqueObjects = [];
	objects.forEach(obj => {
		if (uniqueValues.indexOf(obj[key]) === -1 && obj[key] !== null && obj[key] !== undefined) {
			uniqueValues.push(obj[key]);
			uniqueObjects.push(obj);
		}
	});
	return uniqueObjects;
}

export function deleteCookies() {
	document.cookie.split(";").forEach(c => {
		document.cookie = c
			.replace(/^ +/, "")
			.replace(/=.*/, "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;max-age=0;path=/");
	});
}

// adapted from https://gist.github.com/marcelo-ribeiro/abd651b889e4a20e0bab558a05d38d77
export function slugify(str) {
	const map = {
		a: "á|à|ã|â|ä|À|Á|Ã|Â|Ä",
		e: "é|è|ê|ë|É|È|Ê|Ë",
		i: "í|ì|î|ï|Í|Ì|Î|Ï",
		o: "ó|ò|ô|õ|ö|Ó|Ò|Ô|Õ|Ö",
		u: "ú|ù|û|ü|Ú|Ù|Û|Ü",
		c: "ç|Ç",
		n: "ñ|Ñ",
		"": "\\W",
	};

	let retString = str;

	Object.keys(map).forEach(pattern => {
		retString = retString.replace(new RegExp(map[pattern], "g"), pattern);
	});
	return retString;
}



// WEBPACK FOOTER //
// ./src/lib/util.js